import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import CornMasaFlourProduct from 'models/CornMasaFlourProduct'
import CornMasaFlourPackage from './CornMasaFlourPackage'

const productOptions = {
  packagingInfo: <CornMasaFlourPackage />,
  productTitle: 'Corn Masa Flour',
  model: CornMasaFlourProduct,
  validCategories: ['16'],
  validSubCategories: ['016'],
}

const CornMasaFlour = () => <ProductForm product={productOptions} />

export default CornMasaFlour
